import React, { FC } from 'react'
import Video, { VideoType } from '@bt-react/components/Video'
import { TrackProps } from './types'
import style from './Tracks.module.scss'
import { LocalVideoTrackPublication, RemoteVideoTrackPublication } from 'twilio-video'
import isScreenshareTrack from '../../lib/isScreenshareTrack'

const createTrackElements = (publication: LocalVideoTrackPublication | RemoteVideoTrackPublication | undefined, props: TrackProps) => {

  if (!publication) return null

  const key = `track-${publication.kind}-${publication.trackSid}`
  const { trackType = VideoType.VideoTrackType.WEBCAM } = props

  if (trackType === VideoType.VideoTrackType.SCREENSHARE && !isScreenshareTrack(publication)) return null

  return <Video
    key={key}
    publication={publication}
    trackSid={publication.trackSid}
    isHidden={false}
    mirrorVideo={props.presenter.local && trackType === VideoType.VideoTrackType.WEBCAM}
    trackType={trackType}
  />

}

/** Returns a component containing the HTML5 video and audio tracks */
const Tracks: FC<TrackProps> = props =>
  <div className={style['tracks__container']} data-bdd='talks-tracks-container'>
    {
      createTrackElements(props.enabledVideoTracks.find(track => track.kind === 'video'), props)
    }
  </div>

export default Tracks
